const autoNgTemplateLoaderTemplate1 = require('./licenses-datatable.html');

export const licensesDatatable = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: { dataset: '<', titleIcon: '@', tableKey: '@', orderBy: '@', removeAction: '<', updateAction: '<', reverseOrder: '<', copyLicenseKey: '<' },
};
